function UnitInfo() {
    /// <summary>
    /// This object provides client-side functions for the Widget.Unit.UnitInfo Visual. <br/>
    /// basically just calls the get data from the visual and sets the clocktimer
    /// Uses the load type 3 === UNIT table loading
    /// <br/>
    /// Author: MWI<br />
    /// Date: 20.01.2017<br />
    /// Copyright ©: EUDT GmbH 2017 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 20.01.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>  
};
UnitInfo.prototype = new vcTemplate();

UnitInfo.prototype.init = function () {
    /// <summary>
    /// This function inits the the Object <br/>
    /// it adds the clickhandler, the filter and the caleander <br/>
    /// further, it loads the initial content
    /// </summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.showInfo("", "", false);
        window.VisualCoreService.getDataByName("VISUAL_UNIT_SYSTEMOVERVIEW", '1', getCurrentTimestamp(), me.visual.width(), me.visual.height(), "", "", 1, JSON.stringify({ "type": 3, "bluid": me.bluid }), function (result) {
            me.visual.html(result);
            me.visual.find(".clock").vcClockTimer({ width: "500px" });
            me.visual.find('.cl').off('click');
        });

        return true;
    } catch (ex) {
        me.writeError("UnitInfo.init", ex);
        return false;
    }
};

//#END REGION FILTER